module.exports = __webpack_public_path__ + "static/media/linkedin.5604c6cb.svg";